import { useTranslation } from "react-i18next"

import React from "react"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import AdminsTable from "./AdminsTable"

export default function AdminsList() {
  const { t } = useTranslation()

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("pages.Admins")} />
        <AdminsTable />
      </div>
    </div>
  )
}
